import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Axios from './request/config'
import * as THREE from 'three'
import pinia from './stores'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18nPlugin from './plugins/i18n'

const app = createApp(App);
app.config.globalProperties.$THREE = THREE;  //挂载到原型
app.config.globalProperties.$Axios = Axios;
app.config.globalProperties.$ShopopeeUrl = process.env.NODE_ENV === 'production' ? 'https://www.3dshopopee.com/' : 'http://127.0.0.1:91/';
app.config.globalProperties.$EShopopeeUrl = process.env.NODE_ENV === 'production' ? 'shop02.e-shopopee.com' : '127.0.0.1:91/eshopopee';
app.config.globalProperties.$ThreeDShopopeePath = process.env.NODE_ENV === 'production' ? "https://www.3dshopopee.com/3d/" : "http://127.0.0.1:91/3d/"

app.config.globalProperties.$chatHttp = process.env.NODE_ENV === 'production' ? "https://www.3dshopopee.com/api" : "http://192.168.1.5:91/api";
app.config.globalProperties.$SSL = process.env.NODE_ENV === 'production' ? "https" : "http";
app.config.globalProperties.$ShopopeeHttp = process.env.NODE_ENV === 'production' ? 'https://www.3dshopopee.com/shopopeeApi/' : 'http://127.0.0.1:91/shopopeeApi/';
app.config.globalProperties.$versionNum = "0.0.114"

Axios.defaults.timeout = 500000
Axios.baseURL = app.config.globalProperties.$ShopopeeUrl

app.use(router).use(pinia).use(ElementPlus).use(i18nPlugin).mount('#app')

const globals = app.config.globalProperties
export { globals }

